import { TFunction } from 'i18next';

import { LessonProgressCardItemProps } from '@/components/lesson/LessonProgressCard/types';
import percentage from '@/utils/statistics/percentage';

type LessonItemBadgeParams = Pick<
  LessonProgressCardItemProps,
  'status' | 'pendingCount' | 'progress'
>;

export default function getLessonItemBadgeLabel(
  { status, pendingCount, progress }: LessonItemBadgeParams,
  t: TFunction,
): string | undefined {
  if (status !== 'pending') return undefined;

  if (pendingCount) return String(pendingCount);

  if (progress !== undefined)
    return t('performanceValue', { value: percentage(progress, 0) });

  return undefined;
}
